import { render, staticRenderFns } from "./services.vue?vue&type=template&id=a707113e&scoped=true&"
var script = {}
import style0 from "./services.vue?vue&type=style&index=0&id=a707113e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a707113e",
  null
  
)

export default component.exports